module.exports = __webpack_public_path__ + "img/dice-three.0c4745cb.svg";